import React, { Component } from 'react'
import { withFirebase } from '../../config';
import { Input, Button, Modal, TextArea } from 'semantic-ui-react';

/*Redux */
import 'firebase/firestore';
import 'firebase/auth';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
/**Other Component */
import UploadImage from '../S3Uploading/UploadImage';

/*Actions */
import {
    fetchAllMainValues,
    addMainValue,
    emptyMainValue
} from '../../Actions/ContentMainValuesAction';

const INITIAL_STATE = {

    showModal: '',
    /////////// FAQ
    text: '',
    text_in_english: '',
    number: 0,
    imageUrl: '',
    description: '',
    description_in_english: '',

};

export class AddMainValue extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    static getDerivedStateFromProps(nextprops, state) {
        if (nextprops.showModal) {
            return {
                showModal: nextprops.showModal
            }
        }
        return state;
    }

    addMainValue(text, description, imageUrl, number, text_in_english, description_in_english) {
        this.props.addMainValue(text, description, imageUrl, number, text_in_english, description_in_english);
    }

    getImageUrl(imageUrl) {

        if (imageUrl) {
            this.setState({ imageUrl: imageUrl });
            console.log("imgURL in Main Value = " + this.state.imageUrl);
        }
    }

    handleChange = (e) => {
        switch (e.target.name) {
            default:
                this.setState({ [e.target.name]: e.target.value });
        }
    }

    handleSubmit = (e) => {

        const { text, number,
            imageUrl,
            description, text_in_english, description_in_english } = this.state;

        this.addMainValue(text, description, imageUrl, number, text_in_english, description_in_english);

        e.preventDefault();
        this.setState({
            text: '',
            number: 0,
            imageUrl: '',
            description: '',
            text_in_english: '',
            description_in_english: '',
        })

    }

    closeModal = (e) => {
        this.setState({ showModal: false })
    }

    openModal = (e) => {
        this.setState({ showModal: true })
    }

    render() {

        const { text, number, imageUrl, text_in_english } = this.state;

        const { error } = this.props;
        const { success } = this.props;

        const isInvalidText =
            text === '' ||
            number === 0 ||
            imageUrl === '' ||
            text_in_english === '';

        const { loading } = this.props;
        let $buttonSubmitLoader = (
            <Button onClick={this.handleSubmit}
                disabled={isInvalidText}
                id="saveButton" >
                Add
            </Button>);

        if (loading === true) {
            $buttonSubmitLoader = (
                <button id="saveButton"
                    class="ui loading button">
                    Loading</button>);
        }

        if (success === false) {
            alert("error messing data or network " + error)
            this.props.emptyMainValue();
        }
        else if (success === true) {
            alert("Main Value added Successfully")
            this.props.emptyMainValue();
            this.props.fetchAllMainValues();

            this.closeModal();
            this.setState({
                text: '',
                number: 0,
                imageUrl: '',
                description: '',
                text_in_english: '',
                description_in_english: '',
            })

        }



        return (
            <Modal id="modal"
                trigger={
                    <button className="btn btn-lg btn-primary add-btn float-right mb-0"
                        type="submit" onClick={this.openModal}> + Add New </button>}
                onClose={this.closeModal} open={this.state.showModal}>
                <Modal.Header>Add New Main Value</Modal.Header>
                <Modal.Content >
                    <Modal.Actions>

                        <div className="">
                            <form className="white" onSubmit={(e)=> e.preventDefault()}>
                                <div className="row">

                                    {/* image Uploader */}
                                    <div className="col-md-4 col-12">
                                        <div className="">
                                            <span className="required_input">*</span>
                                            <UploadImage getImageURLCallBack={this.getImageUrl.bind(this)}
                                                imageUrl={this.state.imageUrl}
                                                imagepreview={this.state.imageUrl}
                                                s3DirectryrName='contentvalue' />
                                        </div>

                                    </div>

                                    <div className="col-md-8 col-12">

                                        <label htmlFor="text" className="label">
                                            <span className="required_input">*</span>
                                            Text</label>
                                        <input fluid name="text" id="text"
                                            dir="auto"
                                            className="form-control"
                                            onChange={this.handleChange}
                                            value={this.state.text} />
                                        <br />

                                        <label htmlFor="text_in_english" className="label">
                                            <span className="required_input">*</span>
                                            Text In English</label>
                                        <input fluid name="text_in_english" id="text_in_english"
                                            dir="auto"
                                            className="form-control"
                                            onChange={this.handleChange}
                                            value={this.state.text_in_english} />
                                        <br />

                                        <label htmlFor="number"
                                            className="label">
                                            <span className="required_input">*</span>
                                            Number</label>
                                        <br />
                                        <Input fluid type="number" min="0"
                                            name="number" id="number"
                                            onChange={this.handleChange}
                                            value={this.state.number} />
                                        <br />


                                        <label htmlFor="description"
                                            className="label">Description</label><br />
                                        <textarea fluid rows="6"
                                            dir="auto"
                                            className="form-control"
                                            name="description"
                                            id="episode_description"
                                            onChange={this.handleChange}
                                            value={this.state.description} />
                                        <br />

                                        <label htmlFor="description_in_english"
                                            className="label">Description In English</label><br />
                                        <textarea fluid rows="6"
                                            dir="auto"
                                            className="form-control"
                                            name="description_in_english"
                                            id="description_in_english"
                                            onChange={this.handleChange}
                                            value={this.state.description_in_english} />
                                        <br />

                                    </div>

                                </div>

                                <div className="input-field">

                                    {$buttonSubmitLoader}



                                </div>
                                {error && <p>{error.message}</p>}
                            </form>


                        </div>
                    </Modal.Actions>
                </Modal.Content>
            </Modal>
        )
    }
}

AddMainValue.propTypes = {
    addMainValue: propTypes.func.isRequired,
}
const mapStateToProps = state => ({
    showModal: state.contentMainValue.showModal,
    error: state.contentMainValue.adding_main_values_error,
    success: state.contentMainValue.adding_main_values_sucessfully,
    loading: state.contentMainValue.loading
});


export default withFirebase(
    connect(
        mapStateToProps,
        {
            addMainValue,
            emptyMainValue,
            fetchAllMainValues
        }
    )
        (AddMainValue)
);
